/**
 * Localização de uma anotação de label.
 */

export default class LabelAnnotationLocation {

    /**
     * @param {string | null} especificacao
     * @param {{id: string, text: string, color: string | undefined, porcoes: string[]}[]} regioesAnatomicas
     * @param {{id: string, text: string, color: string | undefined, faces: string[], porcoes: string[]}[]} dentes
     * @param {string | null} especificacaoInterna
     * @example
     * new LabelAnnotationLocation('abaixo_dente', [{id: 'lb_regiaoAnatomica1', text: 'Região anatômica 1', color: 'blue', porcoes: ['incisura_mandibula']}], [{id: 'lb_dente1', text: 'Dente 1', color: 'blue', faces: ['mesial', 'distal'], porcoes: ['apical']}]
     */
    constructor(especificacao = null, regioesAnatomicas = [], dentes = [], especificacaoInterna = null) {
        /** Especificação da localização.
         * @type {string | null}
        */
        this.especificacao = especificacao || null;
        /** Especificação interna da localização.
         * @type {string | null}
        */
        this.especificacaoInterna = especificacaoInterna || null;
        /** Regiões anatômicas.
         * @example
         * [{id: 'lb_regiaoAnatomica1', text: 'Região anatômica 1', color: 'blue', porcoes: ['incisura_mandibula']}]
         * @type {{id: string, text: string, color: string | undefined, porcoes: string[]}[]}
        */
        this.regioesAnatomicas = regioesAnatomicas || [];
        /** Dentes.
         * @example
         * [{id: 'lb_dente1', text: 'Dente 1', color: 'blue', faces: ['mesial', 'distal'], porcoes: ['apical']}]
         * @type {{id: string, text: string, color: string | undefined, faces: string[], porcoes: string[]}[]}
        */
        this.dentes = dentes || [];
    }

    /**
     * @param {Object} object
     * @returns {LabelAnnotationLocation}
     */
    static fromObject(object) {
        return new LabelAnnotationLocation(object.especificacao, object.regioesAnatomicas, object.dentes);
    }

    toObject() {
        return JSON.parse(JSON.stringify(this));
    }
}